import { v4 as uuidv4 } from 'uuid'
import { isProduction } from '../config/environments'

export const generateUID = () => {
  return uuidv4()
}

export const addTMXScriptToBody = (TMX_ID) => {
  return new Promise((resolve, reject) => {
    const tmxOrgIdJ = isProduction() ? '51pz0o4y' : '9uviz06v'
    const oldScript = Array.from(document.scripts).find((s) =>
      s.src.includes(tmxOrgIdJ)
    )

    if (oldScript) {
      oldScript.parentNode.removeChild(oldScript)
    }

    const tmxScriptUrl = `https://ocs.ameriprise.com/fp/tags.js?org_id=${tmxOrgIdJ}&session_id=${TMX_ID}`
    const script = document.createElement('script')
    script.src = tmxScriptUrl
    script.type = 'text/javascript'

    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Script failed to load'))

    document.head.appendChild(script)
  })
}
